import React, { useEffect, useState, useCallback, useRef } from "react";
import { useHistory, withRouter } from "react-router-dom";
import { connect, useSelector, useDispatch } from "react-redux";
import RegisterBanner from "../../components/banners/RegisterBanner";
import StoreMenu from "../../components/layout/header/store-menu";
import axios from "axios";
import aboutbg from "../../assets/images/aboutbg.png";
import aboutimage from "../../assets/images/aboutimage.png";
import Parser from "html-react-parser";
import { useParams } from "react-router-dom";
import { Row, Col, Card } from "reactstrap";
import OwlCarousel from "react-owl-carousel2";
import AboutUs from "../../assets/images/About-us.jpeg";
import Contact from "../../assets/images/Contact-us.jpeg";
import aboutSec from "../../assets/images/about-inside.jpeg";
import { Tabs, TabList, Tab, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import { Link } from "react-router-dom";
import { setCartData } from "../../actions/cart-action-type";
import TrustedLogo from "../../../src/assets/images/logos/trusted.svg";
import Alert from "@mui/material/Alert";
import { Snackbar } from "@material-ui/core";
import ProductList from "../../components/productList";
import EcommerceGuarantees from "../../components/ecommerce-guarantees";
import globalConfig from "../../globalConfig";
import CollectionBanner from "../../components/banners/CollectionBanner";
import { Helmet } from "react-helmet";
import "./style.scss";

const About = (props) => {
  const params = useParams();
  const [data, setData] = useState();

  useEffect(() => {
    globalConfig.isStorePage = true;
    const bodyForm = new FormData();
    bodyForm.append("action", "pageDetails");
    bodyForm.append("destination_slug", "gsharshop");
    bodyForm.append("page_slug", params.page_slug);
    axios.post(process.env.REACT_APP_BASE_URL, bodyForm).then((res) => {
      console.log(res.data.data);
      setData(res.data.data);
    });
  }, [params.page_slug]);

  const options1 = {
    replace: (domNode) => {
      if (domNode.attribs && domNode.attribs.class === "remove") {
        return <></>;
      }
    },
  };

  return (
    <div className="productdetail">
      <StoreMenu />
      <CollectionBanner
        backgroundImage={params.page_slug === "about" ? AboutUs : Contact}
        titleArr={[
          {
            title: "Home",
            link: "/",
          },
          {
            title: params.page_slug === "about" ? "About" : "Contact",
            link: "",
          },
        ]}
        title={params.page_slug === "about" ? "About" : "Contact"}
      />

      {params.page_slug === "about" ? (
        <div className="container about-cont">
          <div className="section1">
            <div className="textsec">
              <h3
                style={{
                  color: "#202434",
                  fontSize: "40px",
                  fontWeight: 600,
                }}
              >
                Who are we
              </h3>
              <p
                style={{
                  color: "#2E323B",
                  fontSize: "16px",
                  fontWeight: 500,
                  marginTop: "30px",
                  marginBottom: "20px",
                }}
              >
                Gshar is Emirati slang that stands for “things", which is
                exactly what you would find in store, handcrafted things, hand
                painted things, all created by artists in the UAE and around the
                region.
              </p>
              <p
                style={{
                  color: "#2E323B",
                  fontSize: "16px",
                  fontWeight: 500,
                  marginTop: "30px",
                  marginBottom: "20px",
                }}
              >
                We have been home to artists for over 3 years, branching out
                from Shurooq (Sharjah Investment and Development Authority), we
                seek to find homegrown talent, whether it be an Emirati artist
                or an expat to collaborate with, showcase, and sell their work.
              </p>
              <p
                style={{
                  color: "#2E323B",
                  fontSize: "16px",
                  fontWeight: 500,
                  marginBottom: "70px",
                }}
              >
                Our message is simple, to support artists
              </p>
            </div>
            <div className="imgsec">
              <img
                src={aboutbg}
                alt=""
                style={{
                  position: "absolute",
                  right: "-60px",
                }}
              />
            </div>
          </div>

          <img
            src={aboutSec}
            alt=""
            style={{
              width: "100%",
              borderRadius: "10px",
            }}
          />

          <p className="textsec2">
            We like to believe that our concept is evolving and not stand still,
            when Gshar first opened its doors, the focus was to solely support
            local artists and artwork linked to the rich culture of the UAE. Our
            focus is still the same but we want to make room for artists from
            all around who can specifically show the beauty, diversity, and
            creativity that can be found in the UAE and the region.
          </p>
        </div>
      ) : (
        <div
          className="container"
          style={{ fontSize: 24, padding: "5rem", fontWeight: 600 }}
        >
          {/* <iframe
            id="JotFormIFrame-222829298518469"
            title="Modern Contact Form"
            onload="window.parent.scrollTo(0,0)"
            allowtransparency="true"
            allowfullscreen="true"
            allow="geolocation; microphone; camera"
            src="https://form.jotform.com/222829298518469"
            frameborder="0"
            style={{ minWidth: "100%", height: "539px", border: "none" }}
            scrolling="no"
          >
            {" "}
          </iframe>
          <Helmet></Helmet> */}
          For inquiries on items please reach us on{" "}
          <a
            href="https://api.whatsapp.com/send/?phone=971564005045&lang=ar"
            target="_blank"
          >
            Whatsapp
          </a>{" "}
          or call us on
          <a href="tel:0564005046"> 0564005046</a>
          <br />
          <br />
          <br />
          To join us as an Artist reach us on Instagram (
          <a href="https://www.instagram.com/gsharshop/" target="_blank">
            @gsharshop
          </a>
          )
        </div>
      )}
    </div>
  );
};

export default connect()(withRouter(About));
